import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';

import { Icon } from 'components/Icon';
import { HiddenInput } from 'components/HiddenInput';
import { CalculatorModal } from 'components/CalculatorModal';
import { ButtonLabel } from 'components/Button';

const subTypes = [
  {
    key: 'instrument',
    name: 'Инструменты',
    childs: ['Инструмент для оренди', 'Риштування для оренди'],
  },
  {
    key: 'consumables',
    name: 'Расходники',
    childs: ['Видаткові матеріали для оренди'],
  },
];

const ReserveTable = ({ canChange, instrumentsList, onUpdate, onRemove }) => {
  const [openInst, setOpenInst] = useState([]);
  const [calculator, setCalculator] = useState(null);
  const [activeType, setActiveType] = useState(subTypes[0]);

  const handleSelect = (type) => {
    setActiveType(type);
  };

  const handleRemove = (instrumentId) => {
    if (onRemove && instrumentId) {
      const findIndex = openInst.indexOf(instrumentId);

      if (findIndex !== -1) {
        const newArray = openInst.slice();
        newArray.splice(findIndex, 1);

        setOpenInst(newArray);
      }

      onRemove(instrumentId);
    }
  };

  const updateComponent = (instrument, componentId, value) => {
    if (instrument && instrument.components) {
      const componentIndex = instrument.components.findIndex((comp) => comp.id === componentId);

      /// Если компонент найден, изменяем его в инструменте
      if (componentIndex !== -1) {
        const newComponents = instrument.components.slice();
        newComponents[componentIndex] = { ...newComponents[componentIndex], quantity: value };

        onUpdate(instrument.id, { ...instrument, components: newComponents });
      }
    }
  };

  const removeComponent = (instrument, componentId) => {
    if (instrument && instrument.components) {
      const componentIndex = instrument.components.findIndex((comp) => comp.id === componentId);

      /// Если компонент найден, удаляем его из инструмента
      if (componentIndex !== -1) {
        const newComponents = instrument.components.slice();

        newComponents.splice(componentIndex, 1);
        onUpdate(instrument.id, { ...instrument, components: newComponents });
      }
    }
  };

  const handleCalculator = (item) => {
    setCalculator(item);
  };

  const handleCloseCalculator = () => {
    setCalculator(null);
  };

  const handleOpen = (inst) => {
    /// Показать/Спрятать компоненты инструментов
    if (inst.components) {
      const newArray = openInst.slice();

      if (openInst.includes(inst.id)) {
        const index = newArray.findIndex((item) => item === inst.id);

        if (index !== -1) {
          newArray.splice(index, 1);
        }
      } else {
        newArray.push(inst.id);
      }

      setOpenInst(newArray);
    }
  };

  const filterInst = useMemo(() => {
    const list = {};

    subTypes.forEach(({ key, childs }) => {
      if (!list[key]) {
        list[key] = [];
      }

      if (instrumentsList) {
        list[key] = instrumentsList.filter((inst) => childs.includes(inst.subtype));
      }
    });

    return list;
  }, [instrumentsList]);

  return (
    <div className="table-transfer">
      <div className="table-wrapper">
        <div className="table-action-buttons">
          {subTypes
            .filter((subtype) => canChange || filterInst[subtype.key].length > 0)
            .map((subtype) => (
              <ButtonLabel
                key={subtype.key}
                onClick={() => handleSelect(subtype)}
                active={subtype.name === activeType?.name}
                text={subtype.name}
              />
            ))}
          <div className="title title-table">Инструмент</div>
        </div>

        <table className="table-instruments">
          <thead>
            <tr className="table-inst-htr">
              <th className="table-inst-th" width="30px">
                №
              </th>
              <th className="table-inst-th" width="16px" style={{ borderRight: 'none', textAlign: 'left' }}></th>
              <th className="table-inst-th" align="start">
                Наименование
              </th>
              <th className="table-inst-th" width="50px">
                Ед.изм
              </th>
              <th className="table-inst-th" width="50px">
                Кол-во
              </th>
              <th className="table-inst-th" width="50px"></th>
            </tr>
          </thead>
          <tbody>
            {filterInst[activeType.key].map((inst, i) => {
              let icon = 'instrument';

              if (inst.is_priced_by_wear) {
                icon = 'wheel';
              } else if (inst.components && openInst.includes(inst.id)) {
                icon = 'tableminus';
              } else if (inst.components && !openInst.includes(inst.id)) {
                icon = 'tableplus';
              }

              return (
                <React.Fragment key={inst.id}>
                  <tr className="table-inst-tr" onClick={() => handleOpen(inst)}>
                    <th className="table-inst-th text-light">{i + 1}</th>

                    <th className="table-inst-th text-light" style={{ borderRight: 'none', textAlign: 'left' }}>
                      <Icon name={icon} style={{ margin: 'auto' }} />
                    </th>

                    <th className="table-inst-th text-light" align="start">
                      {inst.title}
                    </th>

                    <th className="table-inst-th">шт</th>

                    <th className="table-inst-th">
                      <HiddenInput
                        canChange={canChange}
                        value={inst.quantity}
                        onChange={(value) => onUpdate(inst.id, { ...inst, quantity: value })}
                      />
                    </th>

                    {activeType.key === 'instrument' ? (
                      <th className="table-inst-th double-th">
                        {canChange && <Icon name="trash" onClick={(e) => handleRemove(inst.id)} />}

                        <Icon name="calculator" onClick={() => handleCalculator(inst)} />

                        {calculator?.id === inst.id && (
                          <CalculatorModal
                            instrument={calculator || null}
                            onClose={handleCloseCalculator}
                            disabled={true}
                          />
                        )}
                      </th>
                    ) : (
                      <th className="table-inst-th">
                        {canChange && (
                          <Icon name="trash" onClick={() => handleRemove(inst.id)} style={{ margin: 'auto' }} />
                        )}
                      </th>
                    )}
                  </tr>

                  {/* Компоненты инструмента */}
                  {openInst.includes(inst.id) &&
                    inst.components &&
                    inst.components.map((comp) => (
                      <tr key={comp.id} className="table-inst-tr">
                        <th className="table-inst-th text-light"></th>

                        <th
                          className="table-inst-th text-light"
                          style={{ borderRight: 'none', textAlign: 'left' }}
                        ></th>

                        <th className="table-inst-th text-light" align="start">
                          {comp.title}
                        </th>

                        <th className="table-inst-th">шт</th>

                        <th className="table-inst-th">
                          <HiddenInput
                            canChange={canChange}
                            value={comp.quantity}
                            onChange={(value) => updateComponent(inst, comp.id, value)}
                          />
                        </th>

                        <th className="table-inst-th">
                          {canChange && (
                            <Icon
                              name="trash"
                              onClick={() => removeComponent(inst, comp.id)}
                              style={{ margin: 'auto' }}
                            />
                          )}
                        </th>
                      </tr>
                    ))}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

ReserveTable.propTypes = {
  instrumentsList: PropTypes.array,
  onRemove: PropTypes.func,
  onUpdate: PropTypes.func,
  canChange: PropTypes.bool,
};

ReserveTable.defaultProps = {
  instrumentsList: [],
  onUpdate: () => {},
  onRemove: () => {},
  canChange: true,
};

export { ReserveTable };
